import React from 'react';

export function StaymentManagementIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="gerenciamento da estadia"
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 20 20"
      {...props}
    >
      <g clipPath="url(#clip0_2686_20450)">
        <g clipPath="url(#clip1_2686_20450)">
          <path d="M15.5461 12.6303C15.4439 12.6302 15.3427 12.6496 15.2483 12.6876C15.1539 12.7256 15.0681 12.7813 14.9958 12.8515C14.9236 12.9217 14.8663 13.0051 14.8272 13.0969C14.7882 13.1887 14.7681 13.2871 14.7682 13.3864C14.767 14.2574 14.4569 15.1013 13.8901 15.7758C13.3233 16.4503 12.5345 16.9141 11.6569 17.0891V11.494H14.7657C14.972 11.494 15.1698 11.4143 15.3157 11.2725C15.4616 11.1307 15.5435 10.9384 15.5435 10.7378C15.5435 10.5373 15.4616 10.3449 15.3157 10.2031C15.1698 10.0613 14.972 9.98164 14.7657 9.98164H11.6543V9.08889C12.1733 8.91051 12.6107 8.55952 12.8893 8.09795C13.1678 7.63638 13.2695 7.09395 13.1764 6.56653C13.0833 6.03911 12.8014 5.56065 12.3806 5.21574C11.9597 4.87082 11.427 4.68164 10.8765 4.68164C10.326 4.68164 9.7933 4.87082 9.37244 5.21574C8.95158 5.56065 8.66969 6.03911 8.57661 6.56653C8.48352 7.09395 8.58522 7.63638 8.86374 8.09795C9.14227 8.55952 9.57969 8.91051 10.0987 9.08889V9.98411H6.98731C6.78102 9.98411 6.58318 10.0638 6.4373 10.2056C6.29143 10.3474 6.20948 10.5397 6.20948 10.7403C6.20948 10.9408 6.29143 11.1332 6.4373 11.275C6.58318 11.4168 6.78102 11.4964 6.98731 11.4964H10.0987V17.0916C9.22102 16.9166 8.43227 16.4528 7.86548 15.7783C7.29869 15.1038 6.98853 14.2599 6.98731 13.3889C6.98731 13.1884 6.90537 12.996 6.75949 12.8542C6.61362 12.7124 6.41578 12.6327 6.20948 12.6327C6.00319 12.6327 5.80533 12.7124 5.65946 12.8542C5.51359 12.996 5.43164 13.1884 5.43164 13.3889C5.43164 14.7926 6.00525 16.1389 7.02628 17.1314C8.04731 18.124 9.43214 18.6816 10.8761 18.6816C12.32 18.6816 13.7049 18.124 14.7259 17.1314C15.7469 16.1389 16.3205 14.7926 16.3205 13.3889C16.3206 13.2896 16.3006 13.1912 16.2615 13.0994C16.2225 13.0076 16.1652 12.9242 16.093 12.854C16.0207 12.7837 15.9349 12.728 15.8405 12.6901C15.7461 12.6521 15.6449 12.6326 15.5427 12.6327L15.5461 12.6303ZM10.879 6.20329C11.0329 6.20329 11.1833 6.24764 11.3112 6.33072C11.4391 6.41381 11.5388 6.53191 11.5977 6.67008C11.6565 6.80825 11.6719 6.96029 11.6419 7.10697C11.6119 7.25366 11.5378 7.38839 11.4291 7.49414C11.3203 7.59989 11.1817 7.67191 11.0308 7.70109C10.8799 7.73027 10.7235 7.71529 10.5814 7.65806C10.4393 7.60082 10.3178 7.5039 10.2323 7.37955C10.1468 7.2552 10.1012 7.10901 10.1012 6.95945C10.1014 6.75897 10.1835 6.56677 10.3293 6.42501C10.4751 6.28324 10.6728 6.20351 10.879 6.20329Z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2686_20450">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(4 4.6814)"
          />
        </clipPath>
        <clipPath id="clip1_2686_20450">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(4 4.6814)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
